import { PermissionStoreModelEnum } from '@domain/profile';

import { RouteSegments } from '@shared/enums';

export enum SideMenuNestedItemHighlightViewModelEnum {
  Highlight = 'HIGHLIGHT',
  NoHighlight = 'NO_HIGHLIGHT',
}

export interface SideMenuNestedItemViewModel {
  routeSegments: RouteSegments[];
  label: string;
  permissions?: PermissionStoreModelEnum[];
  isShortcut?: boolean;
  /**
   * @description
   * If `HIGHLIGHT`, the item will be highlighted regardless of the current route.
   * If `NO_HIGHLIGHT`, the item will not be highlighted regardless of the current route.
   * If undefined, the highlight will be determined by the current route.
   */
  forcedHighlightState?: SideMenuNestedItemHighlightViewModelEnum;
}
